import axios from 'axios';
import { API_URL } from './ApiConfig2';

const api = axios.create({
  baseURL: API_URL
});


api.interceptors.request.use(config => {
  const token = JSON.parse(localStorage.getItem('token')); // já vira string pura

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
